import React, { useEffect, useContext, useState } from 'react'
import { Card, Col, Container, Row } from "react-bootstrap"
import moment from 'moment'

import Get from "../api/Get"
import { APPOINTMENT_BY_DOCTOR } from '../api/Routes'
import { authContext } from "../context/AuthContext"
import { isTodayCita } from "../utils/isTodayCita"
import ProvCardIsTodayCita from './proveedor/ProvCardIsToDayCita'
import ProvCardNoTodayCita from './proveedor/ProvCardNoTodayCita'
import ComponentModalErrorSever from './ComponentModalErrorSever'

export const ProveedorProximasCitas = ({ show=2 }) => {
    const {auth} = useContext(authContext)
    const [citas,setCitas] = useState([])
    const [serverTime, setServerTime] = useState(Date.now())
    const [clientTime, setClientTime] = useState(Date.now())
    const [loading, setLoading] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        let mounted = true;
        const url = `${APPOINTMENT_BY_DOCTOR}/${auth.data.username}/${moment().format('DD-MM-YYYY')}/${show}`
        Get({url: url, access_token: auth.data.access_token})
        .then(res=> {
            //console.log(res)
            if(mounted) {
                setCitas(res.data.data.response.slice(0,show))
                if(res.data.data.response.length > 0){
                    let currentTimeServer = (res.data.data.response[0].currentTime)
                    setServerTime(moment(currentTimeServer, "DD/MM/YYYY HH:mm:ss").toDate().getTime())
                }
                setLoading(false)
            }            
        })
        .catch( error => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        });
        return () => mounted = false;
    },[])

    return (
        <Container fluid>
            {
                (!loading && citas.length) === 0 ?
                <Row>
                    <Col>
                        <Card className="shadow-1">
                            <Card.Body>
                                <h6>No hay citas programadas</h6>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> : (!loading && citas.length > 0) &&
                <Row>
                    {
                        citas.map((item, i)=>(
                            isTodayCita(item.scheduleDTO.dateTimeInit) 
                                ? <Col key={i} xs="12" md="6">
                                    <ProvCardIsTodayCita 
                                        item={item}
                                        serverTime={serverTime}
                                        setServerTime={setServerTime}
                                        clientTime={clientTime}
                                        setClientTime={setClientTime}
                                    />
                                </Col> 
                                : <Col key={i} xs="12" md="6">
                                    <ProvCardNoTodayCita item={item}/>
                                </Col>
                        ))
                    }
                </Row>
            }

            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </Container>
    )
}
